var _defs, _g, _g2, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowniverseAppiconTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app-icon_copy_2",
    "data-name": "app-icon copy 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 925,
    height: 1013,
    viewBox: "0 0 925 1013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n        fill: #263c7b;\r\n      }\r\n\r\n      .cls-1, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1 {\r\n        filter: url(#filter);\r\n      }\r\n\r\n      .cls-2 {\r\n        font-size: 29.167px;\r\n        font-family: Arial;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#filter-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#filter-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #544c92;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #1f52a0;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: -0.063,
    y: 175.438,
    width: 925.063,
    height: 837.592,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: -0.0625,
    y: 175.438,
    width: 925.063,
    height: 837.592,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iOTI1LjA2MyIgaGVpZ2h0PSI4MzcuNTkyIiB2aWV3Qm94PSIwIDAgOTI1LjA2MyA4MzcuNTkyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9IjQxOC43OTYiIHgyPSI5MjUuMDYzIiB5Mj0iNDE4Ljc5NiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmJhNWUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjYzYzdiIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI5MjUuMDYzIiBoZWlnaHQ9IjgzNy41OTIiLz4KPC9zdmc+Cg=="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 691.312,
    y: 231.438,
    width: 50.813,
    height: 50.937,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 691.312,
    y: 231.438,
    width: 50.813,
    height: 50.937,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTAuODEzIiBoZWlnaHQ9IjUwLjkzNyIgdmlld0JveD0iMCAwIDUwLjgxMyA1MC45MzciPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iMjUuNDY5IiB4Mj0iNTAuODEzIiB5Mj0iMjUuNDY5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmYmE1ZSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNjNjN2IiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjUwLjgxMyIgaGVpZ2h0PSI1MC45MzciLz4KPC9zdmc+Cg=="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    x: 663.594,
    y: 300.906,
    width: 32.344,
    height: 32.375,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 663.594,
    y: 300.906,
    width: 32.344,
    height: 32.375,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzIuMzQ0IiBoZWlnaHQ9IjMyLjM3NSIgdmlld0JveD0iMCAwIDMyLjM0NCAzMi4zNzUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iMTYuMTg4IiB4Mj0iMzIuMzQ0IiB5Mj0iMTYuMTg4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmYmE1ZSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNjNjN2IiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjMyLjM0NCIgaGVpZ2h0PSIzMi4zNzUiLz4KPC9zdmc+Cg=="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.892,212.5c-322.183,450.339,172.527,895.18,519.09,634.744,180.84-148.128-.971-398.873,88.851-509.44,30.653-9.5,17.279,84.065,19.13,112.105C799.241,508.552,880,427.04,804.571,300.081c-33.944-69.96-51.273-96.413-23.487-123.221,23.2-20.451,144.054,184.9,143.905,357.732-8.161,181.26-77.674,432.274-442.1,476.928C74.952,1044.28-182.84,525.568,157.892,212.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TM",
    className: "cls-2",
    x: 734.271,
    y: 317.557
  }, "TM"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 716.718,
    cy: 256.906,
    r: 25.406
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.753,300.892a16.2,16.2,0,1,1-16.173,16.2A16.188,16.188,0,0,1,679.753,300.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M897.839,314.9s-50.324-44.582-58.667-123.053c1.968-25.515,34.708-4.7,29.3,4.809C860.942,228.518,897.839,314.9,897.839,314.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M908.186,291.333c-2.771.7-19.628-21.218-21.273-60.946,1.513-35,26.231-24.669,24.942-6.307C910.075,242.856,910.958,290.632,908.186,291.333Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "globe_copy",
    "data-name": "globe copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.909,303.387S205.992,413.669,464.8,521.584c246.105,81.4,255.414-48,255.414-48s42.8,180.682-304.956,59.2C141.068,401.436,302.909,303.387,302.909,303.387Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M551.689,310.787H399.211l72.227,103.6,168.528,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.079,503.185"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M551.689,318.187a35.09,35.09,0,0,0,8.026-7.4c-21.583-17.4-186.586-49.95-192.6,14.8-12.286,103.166,230.162,171.06,280.88,118.4C701.4,366.444,561.816,312.3,561.816,312.3l-11.261,5.883s127.531,57.966,89.411,103.6c-58.271,70.759-254.71-34.993-248.78-88.8C401.218,258.371,551.689,318.187,551.689,318.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.331,525.385s-14.044,119.015,240.754,222c219.355,78.316,329.032-7.4,329.032-7.4s-74.233,118.4-353.107,22.2C66.167,656.117,118.331,525.385,118.331,525.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.507,754.782c109.092,156.555,345.082,103.6,345.082,103.6S300.736,887.6,174.507,754.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M503.538,362.586c-262.155,141.832-301.612,429.2-296.931,429.2C210.62,793.015,284.518,513.36,503.538,362.586Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M487.488,347.786c-38.788-18.5-381.195,51.183-345.082,347.8C149.094,412.536,430.643,354.57,487.488,347.786Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_copy",
    "data-name": "Shape 11 copy",
    className: "cls-6",
    d: "M522.47,367.285c13.752,279.981-226.144,466.983-228.693,463.363C290.47,828.216,504.6,618.775,522.47,367.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.532,392.186S141.26,505.3,391.186,628.984c241.376,98.952,345.082-14.8,345.082-14.8s-70.363,150.861-361.132,37C93.4,521.156,182.532,392.186,182.532,392.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_copy",
    "data-name": "Shape 12 copy",
    className: "cls-6",
    d: "M562.328,381.358C599.4,402.635,699.511,751.532,398.584,862.25,675.682,717.152,585.072,429.872,562.328,381.358Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M856.646,991.58"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.078,294.368v-111s30.513-66.214,178.309-64.981S639.214,183.37,639.214,183.37V303.387s-60.774-44.4-183.827-44.4C318.291,258.987,277.078,294.368,277.078,294.368Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.381,118.389L471.438-.01l321.006,140.6-128.4,42.781S607.2,96.806,463.412,96.189c-150.471-.617-194.359,74-194.359,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.522,119.211h16.144v148.87H183.522V119.211Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M182.532,236.788v37s-19.5,21.737-19.5,29.6v22.2h55v-22.2c0-8.556-19.5-29.6-19.5-29.6v-37H182.532Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowniverseAppiconTransparent);
export default __webpack_public_path__ + "static/media/growniverse-appicon-transparent.896e4b6cdd4bbe4a03bb3692f59444d2.svg";
export { ForwardRef as ReactComponent };